module.exports = __webpack_public_path__ + "img/popup.80950021.png";